import React, { useState, useEffect, useContext } from 'react';
import { Form, Radio } from 'antd';
import Typing from '../Typing/Typing';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp';
import { Context } from '../../ChatContext';
import CmpsMsgStatus from '../CmpsMsgStatus/CmpsMsgStatus';
import * as Utils from '../../services/utils';

function CmpsRegisteredUser({onComplete, onScroll, form, onShowInput}) {
  const [typing, setTyping] = useState(true);
  const [msg, setMsg] = useState(false);
  const [context, setContext] = useContext(Context);
  let list = [
    {label: 'Continuo', value: 'continuo'},
    {label: 'Modifico', value: 'modifico'}
  ];

  const onChange = (e) => {
    setMsg(form.getFieldValue("scelta_censito").label);
    if(form.getFieldValue("scelta_censito").value === 'continuo') {
      Utils.eventsDataLayer('chatbot_cta', 'Conferma dati personali');
      onComplete('step12');
    } else {
      Utils.eventsDataLayer('chatbot_cta', 'Modifica dati personali');
      onComplete('step6');
    }
  }

  useEffect(() => {
    Utils.eventsDataLayer('customPageview', '/chatbot-fissa-appuntamento/controllo-dati');
    onShowInput(false);
    const timer = setTimeout(() => {
      setTyping(false);
      onScroll();
    }, 2200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="cmps-usente-censito">
      {typing && <Typing wait={1200} />}
      {!typing && (
        <div className="messages messages--receiver">
          <div className="message">
            <CmpsAnimation wait={300}>
              <span className="bubble">Bentornat*! Per completare<br /> la richiesta è necessario un<br /> controllo dei tuoi dati<br /> personali.</span>
            </CmpsAnimation>
            <CmpsAnimation wait={600}>
              <span className="bubble">Indirizzo email:<br /> {context.user?.email}</span>
            </CmpsAnimation>
            <CmpsAnimation wait={600}>
              <span className="bubble">Numero di telefono:<br /> {context.user?.telefono}</span>
            </CmpsAnimation>
            <CmpsAnimation wait={900} last={true}>
              <span className="bubble">Vuoi proseguire con questi dati o<br /> preferisci modificarli?</span>
            </CmpsAnimation>
            <CmpsAnimation wait={1200}>
              {!msg && (
              <Form.Item className={`cmps_radio_button cmps_radio_button__consent`} name="scelta_censito">
                <Radio.Group onChange={onChange}>
                  {list.map((item, index) =>
                    <Radio.Button key={index} value={item}>
                      {item.label}
                    </Radio.Button>
                  )}
                </Radio.Group>
              </Form.Item>
              )}
              <div className="info">
                <span className="time"><Timestamp /></span>
              </div>
            </CmpsAnimation>
          </div>
        </div>
      )}
      {msg && (
        <div className="messages messages--sender">
          <CmpsAnimation wait={300}>
            <div className="message">
              <span className="bubble">{msg}</span>
            </div>
            <div className="info">
              <span className="time"><Timestamp /></span>
              <CmpsMsgStatus />
            </div>
          </CmpsAnimation>
        </div>
      )}
    </section>
  );
  
} 

export default CmpsRegisteredUser;